import React from 'react';
import Close from '@spectrum-icons/workflow/Close';
import './sheetHeader.css';

/**
 * The header bar a full-screen dialog wears: identity on the left, an explicit
 * Close on the right, a hairline under it. Every sheet uses this one so they
 * don't each invent their own chrome — and so none of them falls back to
 * Spectrum's floating close button, which has no sensible place to sit once
 * the dialog fills the screen.
 */
export function SheetHeader({ title, subtitle, titleId, onClose, closeLabel = 'Close' }) {
    return (
        <header className="sheetHeader">
            <div className="sheetHeaderIdentity">
                <h2 className="sheetHeaderTitle" id={titleId}>
                    {title}
                </h2>
                {subtitle && <p className="sheetHeaderSub">{subtitle}</p>}
            </div>
            <button type="button" className="buttonReset sheetHeaderClose" onClick={onClose}>
                <Close size="S" />
                <span>{closeLabel}</span>
            </button>
        </header>
    );
}
